// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-popup {
    margin-top: 130px;
    margin-left: 25%;
    width: 50%;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
    padding: 20px;
    z-index: 1;
    text-align: center;
}

.review-popup h2 {
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
}

.form-group {
    margin-bottom: 15px;
    text-align: left;
}

.form-group label {
    display: block;
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.form-group input[type="text"],
.form-group select,
.form-group textarea {
    width: 80%;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 4px;
    outline: none;
    resize: none;
}

.form-group select{
    width:83%;
}

.form-group input[type="text"]:focus,
.form-group select:focus,
.form-group textarea:focus {
    border-color: #007bff;
    box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.2);
}

textarea {
    min-height: 80px;
}

.error-message {
    color: #e74c3c;
        font-size: 14px;
        margin-top: 5px;
    }
    
    .submit-button {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 10px 20px;
        font-size: 16px;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease;
        margin-top: 15px;
        width: 100%;
    }
    
    .submit-button:hover {
        background-color: #0056b3;
    }`, "",{"version":3,"sources":["webpack://./src/Styles/ReviewPopup.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;IAGI,UAAU;IACV,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;;;IAGI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;QACV,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf,sCAAsC;QACtC,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B","sourcesContent":[".review-popup {\n    margin-top: 130px;\n    margin-left: 25%;\n    width: 50%;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);\n    padding: 20px;\n    z-index: 1;\n    text-align: center;\n}\n\n.review-popup h2 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n}\n\n.form-group {\n    margin-bottom: 15px;\n    text-align: left;\n}\n\n.form-group label {\n    display: block;\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 5px;\n}\n\n.form-group input[type=\"text\"],\n.form-group select,\n.form-group textarea {\n    width: 80%;\n    padding: 10px;\n    font-size: 14px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    outline: none;\n    resize: none;\n}\n\n.form-group select{\n    width:83%;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n    border-color: #007bff;\n    box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.2);\n}\n\ntextarea {\n    min-height: 80px;\n}\n\n.error-message {\n    color: #e74c3c;\n        font-size: 14px;\n        margin-top: 5px;\n    }\n    \n    .submit-button {\n        background-color: #007bff;\n        color: white;\n        border: none;\n        padding: 10px 20px;\n        font-size: 16px;\n        border-radius: 4px;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        margin-top: 15px;\n        width: 100%;\n    }\n    \n    .submit-button:hover {\n        background-color: #0056b3;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
